(function () {
  'use strict';
  var busy = false;
  var base = window.Shopify && window.Shopify.routes.root || '/';
  async function getCart() { return (await fetch(base + 'cart.js')).json(); }
  async function change(key, quantity) {
    var response = await fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) });
    var result = await response.json();
    if (!response.ok || result.errors || result.status) throw new Error(result.description || result.errors || window.cartStrings.error);
    return result;
  }
  function groupItems(cart, group) { return cart.items.filter(function (item) { return item.properties && item.properties._hol_cable_group === group; }); }
  document.addEventListener('change', async function (event) {
    var input = event.target;
    var row = input.closest && input.closest('[data-hol-cable-group]');
    if (!row || !input.matches('input[name="updates[]"]') || row.dataset.holCableChild === 'true') return;
    event.stopImmediatePropagation();
    if (busy) return;
    var quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0) return;
    busy = true;
    var component = row.closest('cart-items, mini-cart');
    var line = input.dataset.index;
    var group = row.dataset.holCableGroup;
    var original;
    try {
      if (component && component.enableLoading) component.enableLoading(line);
      original = groupItems(await getCart(), group);
      var parent = original.find(function (item) { return !item.parent_relationship; });
      var child = original.find(function (item) { return item.parent_relationship && item.handle === 'hol-cable-options-2026-09'; });
      if (!parent || !child) throw new Error(window.cartStrings.error);
      if (quantity === 0) await change(parent.key, 0);
      else {
        await change(child.key, quantity);
        await change(parent.key, quantity);
        var actual = groupItems(await getCart(), group);
        if (actual.length !== 2 || actual.some(function (item) { return item.quantity !== quantity; })) throw new Error(window.cartStrings.error);
      }
    } catch (error) {
      if (original && original.length === 2) {
        try {
          var current = groupItems(await getCart(), group);
          for (var i = 0; i < original.length; i++) {
            var old = original[i];
            var match = current.find(function (item) { return item.variant_id === old.variant_id; });
            if (match && match.quantity !== old.quantity) await change(match.key, old.quantity);
          }
        } catch (restoreError) { /* The refreshed cart shows the server's current quantities. */ }
      }
      input.dataset.holCableError = error.message || window.cartStrings.error;
    } finally {
      var errorMessage = input.dataset.holCableError;
      try {
        var fresh = await getCart();
        for (var cart of document.querySelectorAll('cart-items, mini-cart')) {
          cart.classList.toggle('is-empty', fresh.item_count === 0);
          await cart.updateSectionContents();
        }
        var footer = document.getElementById('main-cart-footer');
        if (footer) footer.classList.toggle('is-empty', fresh.item_count === 0);
        if (errorMessage && component && component.updateLiveRegions) component.updateLiveRegions(line, errorMessage);
      } catch (renderError) { window.location.reload(); }
      if (component && component.disableLoading) component.disableLoading();
      busy = false;
    }
  }, true);
  document.addEventListener('click', function (event) {
    if (busy && event.target.closest('cart-remove-button, [name="checkout"], a[href*="/checkout"], quantity-input')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (busy && event.target.closest('cart-items, mini-cart, #cart')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
})();
